export default {
  sectionTitle: 'Authentication factors',
  modalTitle: 'Are you sure you want to reset your authentication factors?',
  modalMessage: 'If you reset your authentication factors, you will need to configure new authentication factors next time you log into My Client Space.',
  noData: 'No authentication factor is configured at this time.',
  confirmButton: 'Confirm',
  updateButton: 'Edit',
  resetButton: 'Reset',
};
